module.exports = __webpack_public_path__ + "assets/img/china.1cad49c4.svg";